export default "__VITE_ASSET__CM1tz7ZL__"